<template>
  <div>
    <div class="columns">
      <div class="column is-6">
        <div class="field">
          <label class="label">{{ $t("query reason code") }}</label>
          <div class="select">
            <select v-model="meta.query_reason_code">
              <option value="1">{{ $t("new credit") }}</option>
              <option value="2">{{ $t("extension") }}</option>
              <option value="3">{{ $t("renovation") }}</option>
              <option value="4">{{ $t("restructuring") }}</option>
              <option value="5">{{ $t("valuation") }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="field">
          <label class="label">{{ $t("figure code") }}</label>
          <div class="select">
            <select v-model="meta.figure_code">
              <option value="1">
                {{ $t("debtor holder or responsible for the account") }}
              </option>
              <option value="2">{{ $t("other debtor holders") }}</option>
              <option value="3">{{ $t("co-debtor or guarantor") }}</option>
              <option value="4">{{ $t("avalist") }}</option>
              <option value="5">{{ $t("legal representative") }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("correlative") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.correlative"
              :placeholder="$t('correlative')"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("request number") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.request_number"
              placeholder="653278"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("first name") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.first_name"
              placeholder="Luis"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("last name") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.last_name"
              placeholder="Robledo"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("birth date") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.birth_date"
              :placeholder="26051985"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("cui") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.cui"
              placeholder="2528360220101"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("nit") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.nit"
              placeholder="6284"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("nit country code") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.nit_country_code"
              placeholder="320"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("passport number") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.passport_number"
              placeholder="252836022"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("passport country code") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.passport_country_code"
              placeholder="320"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("cedula") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.cedula"
              placeholder="A-1 1162934"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("cedula country code") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.cedula_country_code"
              placeholder="320"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("business name") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.business_name"
              placeholder="your business name"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Process_11",
  data() {
    return {
      meta: {
        correlative: "",
        query_reason_code: "",
        request_number: "",
        figure_code: "",
        nit: "",
        cedula: "",
        passport_number: "",
        nit_country_code: "",
        passport_country_code: "",
        birth_date: "",
        first_name: "",
        last_name: "",
        cui: "",
      },
    };
  },
  methods: {
    get_data() {
      return this.meta;
    },
    set_data(data) {
      this.meta = data;
    },
  },
};
</script>

<style scoped>
/* Your component styles go here */
</style>
